import { render, staticRenderFns } from "./SkillsAnalytics.vue?vue&type=template&id=6ac22b36&scoped=true"
import script from "./SkillsAnalytics.vue?vue&type=script&lang=ts"
export * from "./SkillsAnalytics.vue?vue&type=script&lang=ts"
import style0 from "./SkillsAnalytics.vue?vue&type=style&index=0&id=6ac22b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac22b36",
  null
  
)

export default component.exports